var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLr = function SvgIconLr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.743 4.363h18.514a12 12 0 0 0-2.356-2.182H5.1c-.88.62-1.673 1.354-2.357 2.182M0 12q0 .552.05 1.092h23.9a12 12 0 0 0 0-2.182H.05Q0 11.45 0 12M1.309 17.455h21.383q.532-1.038.856-2.182H.452c.215.76.504 1.49.857 2.182M5.1 21.818h13.8c.88-.62 1.673-1.354 2.357-2.182H2.743A12 12 0 0 0 5.1 21.818M.452 8.728H23.55c-.216-.76-.504-1.49-.857-2.182H1.309a12 12 0 0 0-.857 2.182"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74 2.182H18.9A11.95 11.95 0 0 0 12 0c-1.565 0-4.309.808-6.26 2.182M11.479 6.545h11.213c-.4-.78-.881-1.511-1.435-2.181h-9.779zM11.479 10.908H23.95a12 12 0 0 0-.402-2.181h-12.07zM.452 15.274h23.096c.199-.703.335-1.433.402-2.182H.05q.102 1.125.402 2.182M2.743 19.637h18.514a12 12 0 0 0 1.435-2.182H1.309c.399.78.88 1.512 1.434 2.182M12 24c2.569 0 4.948-.807 6.9-2.181H5.1A11.95 11.95 0 0 0 12 24"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M.452 8.727a12 12 0 0 0-.402 2.182H12V-.001C6.507 0 1.876 3.69.452 8.728"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m7.144 3.13.777 2.392h2.515L8.4 7l.777 2.391-2.034-1.477L5.11 9.39 5.887 7 3.853 5.522h2.514z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconLr;